import React from 'react';

const Asterisk = () => {
    return (
        <span className="text-red-600 ml-1 text-sixteen font-regular">*</span>
    )
}

export default Asterisk;
